/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import BaseBigHugeCircuit from '../../implementation-common/big-huge-circuit';
import * as ReverseImplementation from './reverse-implementation';

export default class SallenKeyLowPassBigHugeCircuit extends BaseBigHugeCircuit {
  @computed('c1', 'c2', 'r1', 'r2', 'r3', 'r4', 'opAmpGbw', 'reverseImplementation') get circuitStageValues() {
    var c1 = this.c1;
    var c2 = this.c2;
    var r1 = this.r1;
    var r2 = this.r2;
    var r3 = this.r3;
    var r4 = this.r4;
    var opAmpGbw = this.opAmpGbw;
    var result = ReverseImplementation.computeFromComponentValues(c1, c2, r1, r2, r3, r4, opAmpGbw);
    return result;
  }
}
